import { CircularProgress } from "@mui/material";

const Loading = ({ className, admin, height = "70px", width = "70px" }) => {
  return (
    <div className={`flex place-content-center items-center ${className} `}>
      <CircularProgress
        style={{ width: width, height: height }}
        color={admin ? "secondary" : "primary"}
      />
    </div>
  );
};

export default Loading;
